import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { Form } from "react-bootstrap";
import { PencilFill } from "react-bootstrap-icons";
import { QuestionItem } from "screens/DocumentGeneration/GenerateDiscoveryRequestPage";
import { ReactComponent as DragIndicator } from "images/icon-drag-indicator.svg";

interface Props {
  groupIndex: number,
  questionIndex: number,
  questionCount: number,
  checkedQuestionCount: number,
  editQuestionGroup?: number,
  editQuestionNumber?: number,
  editQuestionText?: string,
  setEditQuestionText: React.Dispatch<React.SetStateAction<string>>,
  q: QuestionItem,
  startingNumber: number,
  editActive: boolean,
  highlightDefinitions: (text: string, key: string) => string | React.ReactNode[],
  handleEditingBlur: () => void,
  handleEditingQuestion: (original: string, groupIndex: number, questionIndex: number) => void,
  handleOnKeyDown(e: React.KeyboardEvent): void
  handleMouseDown: (groupIndex: number, questionIndex: number, e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
  handleMouseEnter: (groupIndex: number, questionndex: number) => void,
  handleMouseUp: () => void,
  dragHandleProps: DraggableProvidedDragHandleProps | null | undefined,
}

export default function Question({ groupIndex,
  questionIndex,
  questionCount,
  checkedQuestionCount,
  editQuestionGroup,
  editQuestionNumber,
  editQuestionText,
  setEditQuestionText,
  q,
  startingNumber,
  editActive,
  highlightDefinitions,
  handleEditingBlur,
  handleEditingQuestion,
  handleOnKeyDown,
  handleMouseDown,
  handleMouseEnter,
  handleMouseUp,
  dragHandleProps
}: Props) {
  return (
    <div
      key={`question-wrapper-${questionCount++}`}
      className={`${q.isChecked ? 'selected' : ''} question-item`}
      onMouseDown={(e) => handleMouseDown(groupIndex, questionIndex, e)}
      onMouseEnter={() => handleMouseEnter(groupIndex, questionIndex)}
      onMouseUp={handleMouseUp}
    >

      <div
        key={`question-check-wrapper-${questionCount}`}
        className="question-item-check-wrapper"
      >
        <Form.Check
          id={`question-check-${questionCount}`}
          key={`question-check-${questionCount}`}
          type={'checkbox'}
          label=""
          checked={q.isChecked}
          onChange={() => {
            // State is already handled by the parent div's handling the check
            // This is just to satisfy React's warning
          }}
        />
      </div>
      {/* Data attribute is added here to let the drag/drop function know this should NOT effect checking off boxes */}
      <div {...dragHandleProps} data-drag-handle="true">
        {/* Needs to displayed via CSS this way because react dnd spits out console warnings when their drag element is removed from the DOM */}
        <DragIndicator style={{ display: q.isChecked ? 'block' : 'none' }} />
      </div>
      <div key={`question-item-number-${questionCount}`} className="question-item-number">{q.isChecked && `${startingNumber + checkedQuestionCount - 1}.`}</div>
      <div
        key={`question-content-${questionCount}`}
        className={`question-item-content${editActive ? ' nohov' : ''}`}
      >
        {(editQuestionGroup === groupIndex && editQuestionNumber === questionIndex) ? (
          <div className="edit-input-container">
            <Form.Control
              id={`edit-${questionCount}`}
              as="textarea"
              autoFocus
              value={editQuestionText}
              style={{ height: '100px' }}
              onChange={e => setEditQuestionText(e.target.value)}
              onBlur={handleEditingBlur}
              onKeyDown={handleOnKeyDown}
              required
            />
          </div>
        ) : (
          <div key={`question-text-${questionCount}`} className="question-text">{highlightDefinitions(q.displayText ?? q.text ?? '', `question-highlight-${questionCount}`)}</div>
        )}
        {!(editQuestionGroup === groupIndex && editQuestionNumber === questionIndex) ?
          <PencilFill key={`edit-pencil-${questionCount}`} className="edit-selection-item" onClick={() => handleEditingQuestion(q.displayText ?? q.text ?? '', groupIndex, questionIndex)} /> : null}
      </div>
    </div>

  )
}
